import React from 'react'
import { useState, useEffect } from 'react'
import { Label, Radio, Input, Image, Loader } from 'semantic-ui-react'
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import './Preferences.scss'
import arrow from '../../assets/arrow.svg'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { createPreferences, getAllAds, getDataPreferencesFromUser } from '../../redux/actions/user';
import { toast } from 'react-toastify';
import { createPreferencesFB, getAdsShield, getUserPreferences } from '../../functions';
import SwitchButton from '../../components/SwitchButton/SwitchButton';

const Preferences = props => {

    const [values, setValues] = useState({})
    const [genre, setGenre] = useState(null)
    const [profession, setProfession] = useState(null)
    const [adblocker, setAdblocker] = useState(null)
    const [checkPref, setCheckPref] = useState([])
    const [errorPhone, setErrorPhone] = useState(null)

    const [ads, setAds] = useState(null)


    useEffect(() => {
        getAds()
        getUserPrefs()
    }, [])

    const getAds = async () => {
        const response = await getAdsShield();
        if(response && response.result) {
            setAds(response.result)
        }
    }

    const getUserPrefs = async () => {
        const response = await getUserPreferences();
        if(response && response.result) {
            if(!response.result.empty) {
                props.history.push('/')
            }
        }
    }

    const handleOnChange = (e, { value }) => {
        setGenre(value)
        setValues({
            ...values,
            genre: value
        })
    }

    const handleOnChangeProfession = (e, { value }) => {
        setProfession(value)
        setValues({
            ...values,
            profession: value
        })
    }

    const handleOnChangeAdBlocker = (e, { value }) => {
        setAdblocker(value)
        setValues({
            ...values,
            adblocker: value === 'Si' ? true : value === 'No' && false
        })
    }

    const handleOnChangeBirthday = e => {

        const {name, value} = e.target;
        setValues({
            ...values,
            [name]: value
        })

    }

    const addAds = id => {

        let arrayCheck = checkPref;

        if(!arrayCheck.includes(id)) {
            arrayCheck.push(id);
        }
        
        setCheckPref([...arrayCheck])
        setValues({
            ...values,
            type_ads: [...arrayCheck]
        })

    }

    const removeAdd = id => {

        let newArrayCheck = checkPref.filter(cp => cp !== id);
        
        setCheckPref([...newArrayCheck])
        setValues({
            ...values,
            type_ads: [...newArrayCheck]
        })

    }

    const handleOnChangeData = e => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value
        })
    }

    const handleSumbit = async () => {

        setErrorPhone(null)
        if((!values.phone || values.phone.length === 0) || (!values.birthday || values.birthday.length === 0)) {
            toast.error('Debes rellenar todos los campos', {
                position: "top-center",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
        }else {
            toast.info('Creando preferencias...', {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
            const response = await createPreferencesFB(values);
            if(response && response.result) {
                toast.success('¡Preferencias creadas con éxito!')
                props.history.push('/')
            }
        }
        

    }

    return (
        <div className='choose_preferences'>
            <div className='content'>
                <h2>REGISTRO</h2>
                <Label>
                    Rellena el siguiente formulario:
                </Label>

                <div className='selectors'>
                    <div>
                        <span>Género</span>
                        <div style={{ display: 'flex', marginBottom: '15px' }}>
                            <Radio 
                                radio
                                label='Masculino'
                                name='genre'
                                value='Masculino'
                                checked={ genre === 'Masculino' }
                                onChange={handleOnChange} />
                            <Radio 
                                radio
                                label='Femenino'
                                name='genre'
                                value='Femenino'
                                checked={ genre === 'Femenino' }
                                onChange={handleOnChange} />
                        </div>
                    </div>
                    <div style={{ marginRight: window.innerWidth < 700 ? '60px' : '0' }}>
                        <span>Profesión</span>
                        <div style={{ display: 'flex' }}>
                            <Radio 
                                radio
                                label='Estudiante'
                                name='profession'
                                value='Estudiante'
                                checked={ profession === 'Estudiante' }
                                onChange={handleOnChangeProfession} />
                            <Radio 
                                radio
                                label='Empleado'
                                name='profession'
                                value='Empleado'
                                checked={ profession === 'Empleado' }
                                onChange={handleOnChangeProfession} />
                            <Radio 
                                radio
                                label='Desempleado'
                                name='profession'
                                value='Desempleado'
                                checked={ profession === 'Desempleado' }
                                onChange={handleOnChangeProfession} />
                        </div>
                    </div>

                    <div style={{ marginTop: '25px' }}>
                        <span>Has usado un AdBlocker anteriormente?</span>
                        <div style={{ display: 'flex' }}>
                            <Radio 
                                radio
                                label='Si'
                                name='adblocker'
                                value='Si'
                                checked={ adblocker === 'Si' }
                                onChange={handleOnChangeAdBlocker} />
                            <Radio 
                                radio
                                label='No'
                                name='adblocker'
                                value='No'
                                checked={ adblocker === 'No' }
                                onChange={handleOnChangeAdBlocker} />
                        </div>
                    </div>

                    <div style={{ marginTop: '25px', marginRight: '20px', width: window.innerWidth > 700 ? '45%' : '60%' }}>
                        <span>Año de Nacimiento</span>
                        <Input 
                            placeholder='Año'
                            icon='long arrow alternate down' 
                            type='text' 
                            name='birthday'
                            onChange={handleOnChangeBirthday}
                            onFocus={ e => e.currentTarget.type = 'date' }
                            onBlur={ e => e.currentTarget.type = 'text' } />
                    </div>
                    <div style={{ marginTop: '25px', marginRight: '20px', width: window.innerWidth > 700 ? '45%' : '90%' }}>
                        <span>Número de teléfono</span>
                        <Input 
                            placeholder='+34 (España)'
                            type='text' 
                            name='phone'
                            onChange={handleOnChangeData} />
                            {
                                errorPhone ? 
                                <h4 style={{ color: 'red' }}>{errorPhone}</h4> : null
                            }
                    </div>
                </div>

                <div className='publicity'>
                    <span>¿Qué tipo de anuncios le interesa más?</span>

                    <div className='publicity_content'>
                        {
                            ads && ads.length > 0 ?
                            ads.map( item => (

                                checkPref.includes(item.id) ?
                                <div 
                                    key={item.id} 
                                    className='publicity_content_item' 
                                    style={{ backgroundImage: `url(${item.image_url})` }} 
                                    onClick={() => removeAdd(item.id)}>
                                    <div className='publicity_content_item_bottom' 
                                    style={{ backgroundColor: '#055c9d' }}
                                    >
                                        <p style={{color: '#fff'}}>
                                            {item.name}
                                        </p>
                                        
                                        <CheckCircleIcon style={{ color: 'white' }} />
                                    </div>
                                </div> :
                                    <div 
                                        key={item.id} className='publicity_content_item' 
                                        style={{ backgroundImage: `url(${item.image_url})` }}
                                        onClick={() => addAds(item.id)}>
                                    <div className='publicity_content_item_bottom' 
                                    style={{ backgroundColor: '#fff' }}
                                    >
                                        <p>
                                            {item.name}
                                        </p>
                                        
                                        <AddCircleIcon /> 
                                    </div>
                                </div>
                            )) : 
                            <Loader active={true}>Cargando tipos de anuncios...</Loader>
                        }
                    </div>
                </div>

                <div className='content_bottom'>
                    <div className='content_bottom_policy'>
                        <SwitchButton />
                        <div className='content_bottom_policy_info'>
                            <span>
                                Al registrarme accepto la politica de privacidad de
                            </span>
                            <span>
                                Shieldata SL. y confirmo que mis datos son precisos.
                            </span>
                            <a target={"_blank"} href='https://www.shield-data.com/es/faq' style={{ color: '#68bbe3' }}>Política de privacidad</a>
                        </div>
                    </div>
                    

                    <Image src={arrow} onClick={handleSumbit} />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    
    // Extraemos los anuncios
    const ads = state.user.ads;
    // una vez creamos las preferencias del usuario, obtenemos su uid para continuar
    const uid = state.user.uid;

    // Comprobamos si el usuario ya tiene registradas sus preferencias
    const result = state.user.result
    const authError = state.user.authError

    return {
        ads,
        uid,
        result,
        authError
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAllAds: () => dispatch(getAllAds()),
        getDataPreferencesFromUser: () => dispatch(getDataPreferencesFromUser()),
        createPreferences: data => dispatch(createPreferences(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Preferences))